import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { DtoReport4detsGetReq } from "./abst/DtoReport4detsGetReq";
import { DtoApiPager } from "./abst/DtoApiPager";

export class DtoReport4detsGetReqImple extends DtoReport4detsGetReq {
  //検索条件
  public date_start: Date | null = null;
  public date_end: Date | null = null;
  public staffId: string | null = null;
  public reportType: string | null = null;
  public freeword: string | null = null;

  //順
  public orderStaff: number | null = null;
  public orderDate: number | null = null;

  public pager = new DtoApiPager();

  public IsValidImple(chkPager: boolean): string[] {
    let res: string[] = new Array();
    //ページャー用入力値チェック
    if (chkPager) {
      this.pager.IsValid4Pager(res);
    } else {
      res = res.concat(super.IsValid());
    }

    return res;
  }
}
